import axiosInstance from "./AxiosInstance";

// Una alerta por equipo y código cada 10 minutos: los reintentos en bucle no
// deben tapar la zona de alertas con la misma falla. El backend aplica el
// mismo límite por si hay varias pestañas abiertas.
const DEDUPE_MS = 10 * 60 * 1000;
const sent = new Map();

export function pduiIdFromLocation() {
  const match = window.location.pathname.match(/\/detail\/(\d+)/);
  return match ? Number(match[1]) : null;
}

/**
 * Alerta de plataforma: un fallo del propio frontend (WebSocket que no
 * reconecta, API sin respuesta) queda en la zona de alertas del equipo que
 * se estaba mirando, junto a las del servidor y las del dispositivo. Nunca
 * lanza ni bloquea.
 */
export function reportPlatformAlert(pduiId, code, message) {
  if (!pduiId || !code) return;
  const key = `${pduiId}:${code}`;
  const now = Date.now();
  if (sent.has(key) && now - sent.get(key) < DEDUPE_MS) return;
  sent.set(key, now);
  axiosInstance
    .post(
      "alert/platform/",
      { pdui_id: pduiId, code, message: String(message || "").slice(0, 500) },
      { timeout: 8000 },
    )
    .catch(() => {});
}
